// prime components
import { ListBox as PrListBox } from 'primereact/listbox'

// styles
import classes from './styles.module.scss'

// types
import type { ListBoxProps } from 'primereact/listbox'
import type { FC } from 'react'

export const ListBox: FC<ListBoxProps> = ({ ...props }) => {
  return <PrListBox {...props} listClassName={classes.listbox} />
}
